import { IOnePageInfo } from "@/types/types";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { useSmartNavigate } from "@/hooks";
import { Spin } from "antd";
import { findMenuTreeNode, getPathWithoutSplats } from "@/utils";
import { getMenus, getLowcodePageInfo } from "@/services";
import { registerSmartPageHistory } from "./utils";
import RenderLowcodePage from "@/pages/render-lowcode-page";
import styles from "./index.module.css";

const LowcodePage = ({ onePageInfo }: { onePageInfo?: IOnePageInfo }) => {
  const location = useLocation();
  const { "*": stackPath } = useParams(); // lowcode页面路由都包含 *? 用于处理onePage, 通过useParams匹配出来（没有前缀 / ）
  const navigate = useSmartNavigate(onePageInfo);
  // 获取有效的低码页面path, 优先从onePageInfo中取
  const path = onePageInfo?.innerPagePath
    ? onePageInfo.innerPagePath
    : getPathWithoutSplats(location.pathname, stackPath);

  const [pageId, setPageId] = useState("");
  const [schema, setSchema] = useState(null);
  const [nodePermitList, setNodePermitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [smartPageHistoryInstance, setSmartPageHistoryInstance] =
    useState(null);

  /**
   * path变化时说明发生了页面切换, 需要重新获取低码schema
   */
  useEffect(() => {
    const getLowcodePageSchema = async () => {
      setLoading(true); // loading
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息
      if (node && node.pageId) {
        try {
          const pageInfo = await getLowcodePageInfo(node.pageId);
          // 从pageInfo中拿到低码页面schema, nodePermitList
          const { code: schema, nodePermitList } = pageInfo;
          setSchema(JSON.parse(schema) || null);
          setNodePermitList(nodePermitList || []);
          setPageId(node.pageId);
          // 当pageType为CREATE时，动态注册smartPageHistory
          if (node.pageType === "CREATE" || node.pageType === "FTP") {
            const historyInstance = registerSmartPageHistory(
              {
                pageType: node.pageType,
                relatedPageInfoList: pageInfo.relatedPageInfoList,
                onePageInfo,
              },
              navigate,
            );
            setSmartPageHistoryInstance(historyInstance);
          } else {
            setSmartPageHistoryInstance(null);
          }
        } catch (error) {
          console.warn("error", error);
        } finally {
          setLoading(false); // 取消 loading
        }
      }
    };
    getLowcodePageSchema();
  }, [path]);

  return (
    <Spin tip="Loading..." spinning={loading}>
      <div className={styles.lowcodePage}>
        <RenderLowcodePage
          key={pageId}
          schema={schema}
          nodePermitList={nodePermitList}
          pageId={pageId}
          location={location}
          navigate={navigate}
          onePageInfo={onePageInfo}
          smartPageHistory={smartPageHistoryInstance}
        />
      </div>
    </Spin>
  );
};

export default LowcodePage;
